import React, { useEffect, useState, useCallback } from 'react';
import { db, setDoc,doc, getDoc , collection, getDocs, query, where } from '../../../config/firebaseConfig.js'; // Pastikan jalur benar
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const Mapping = ({ onSave,soal }) => {
    const [data, setData] = useState([]); // Menyimpan daftar kelas
    const [pembelajaran, setPembelajaran] = useState([]); // Menyimpan ID pembelajaran yang dipilih
    const [error, setError] = useState('');
    const [informasiAkun, setInformasiAkun] = useState(null); // State untuk menyimpan informasi akun
    const navigate = useNavigate();

    // Fetch data kelas
    const fetchUjian = useCallback(async (guruId) => {
        try {
          
            const q = query(collection(db, "ujian"), where("guru_id", "==", guruId));
            const querySnapshot = await getDocs(q);
    
            if (querySnapshot.empty) {
                throw new Error("Tidak ada ujian untuk guru ini.");
            }
    
            const ujianList = [];
    
            // Ambil soal untuk setiap ujian
            for (const doc of querySnapshot.docs) {
                const ujianData = doc.data();
                const soalRef = collection(db, "ujian", doc.id, "soal"); // Koleksi soal di dalam setiap ujian
                const soalSnapshot = await getDocs(soalRef); // Ambil soal berdasarkan id ujian
    
                // Menambahkan jumlah soal ke dalam objek ujian
                ujianList.push({
                    id: doc.id,
                    ...ujianData,
                    soalCount: soalSnapshot.size, // Menyimpan jumlah soal
                });
            }
            setData(ujianList); // Simpan ke state
            console.log(ujianList)
        } catch (error) {
            setError(error.message || "Terjadi kesalahan saat mengambil data ujian.");
        }
    }, []);

    // Handle perubahan checkbox
    const handleCheckboxChange = (id) => {
     

        setPembelajaran((prevSelected) =>
            prevSelected.includes(id)
              ? prevSelected.filter((i) => i !== id) // Hapus jika sudah ada
              : [...prevSelected, id] // Tambah jika belum ada
          );
    };

    // Kirim data ke parent saat tombol "Simpan" diklik
    const handleSaveSoal = () => {
        console.log(pembelajaran)
        onSave(pembelajaran);
    };
useEffect(()  => {
        

        const authToken = localStorage.getItem('authToken');

        if (!authToken) {
            
            return; // Jika tidak ada token, hentikan eksekusi
        }

        try {
            // Decode payload dari token JWT
            const decoded = jwtDecode(authToken);
            setInformasiAkun(decoded); // Simpan informasi akun ke state
            
            // Pastikan fetchUjian & getDataRefrensi ada sebelum dipanggil
            if (decoded.data_id) {
                fetchUjian(decoded.data_id);
            }
        } catch (error) {
            console.error("Error decoding token:", error);
            navigate("/login"); // Jika token tidak valid, arahkan ke halaman login
        }

       
    }, [fetchUjian]);
   

    return (
        <div>
            <div className='row'>
                <div className="col-xl-12 col-md-12">
                    {soal?.length}
                    <table className="table table-borderless mb-0">
                        <thead>
                            <tr>
                                <th>
                                    <input className="form-check-input" type="checkbox" /> ALL
                                </th>
                                <th>Pelajaran (Kelas)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item) => (
                                <tr key={item.id}>
                                    <td align='right' width={20}>
                                    <input 
                                                className="form-check-input" 
                                                value={item.id} 
                                                onChange={() => handleCheckboxChange(item.id)} 
                                                type="checkbox" 
                                                checked={pembelajaran.includes(item.id)}
                                            />
                                                                                </td>
                                    <td>
                                    <h5 className="mb-0">{item.nama} ({item.id})</h5>
                                        <h5 className="mb-0">{item.nama_mapel} ({item.id})</h5>
                                        <small className="text-danger">{item.nama_rombel}</small>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <button type='button' className='btn btn-secondary d-inline-flex' onClick={handleSaveSoal}>Simpan</button>
        </div>
    );
};

export default Mapping;
